import { JsonParam, useQueryParam, withDefault } from "use-query-params";
import { FilterObject } from "./types";
import { FILTERS_GET_PARAM_KEY } from "@/shared/filters-by-meta/model/constants";
import { normalizeFilter } from "@/shared/filters-by-meta/utils/normalize-filter";
import { useMemo } from "react";
import { useFilterMeta } from "@/shared/filters-by-meta/model/use-filter-meta";
import { useMetaFilterConfig } from "@/shared/filters-by-meta/model/meta-filter-config";

export function useFilter<T extends FilterObject>() {
  const meta = useFilterMeta();
  const config = useMetaFilterConfig();

  const JsonParamsWithInitValue = withDefault(JsonParam, config?.initialValue);

  const [innerFilterObject, setFilter] = useQueryParam<T | null>(
    FILTERS_GET_PARAM_KEY,
    JsonParamsWithInitValue,
    {
      removeDefaultsFromUrl: true,
    },
  );

  const reset = () => setFilter(null);

  const filter = useMemo(
    () => normalizeFilter(innerFilterObject, meta),
    [innerFilterObject, meta],
  );

  return {
    filter: filter as T,
    innerFilterObject,
    setFilter,
    reset,
  };
}
